import { AgentSaleActionTypes } from "models/actionTypes/agentSaleActionTypes";
import { ReduxConstants } from "utils/constants";

export const agentSaleMissingInformationSnoozed = (id: number): AgentSaleActionTypes => {
  return {
    type: ReduxConstants.AgentSaleActions.MISSING_INFORMATION_SNOOZED,
    payload: id,
  };
};
